/**
 * <s-variant-sync> — keeps a quick-add hidden variant input in step with a
 * visible variant <select>. Change/input events stop here so an enclosing
 * <s-live-form> (collection filters) does not treat the pick as a filter change.
 */
class SVariantSync extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    const sync = (event) => {
      event.stopPropagation();
      const select = this.querySelector('[data-variant-select]');
      const input = this.querySelector('[data-variant-input]');
      if (select instanceof HTMLSelectElement && input instanceof HTMLInputElement) {
        input.value = select.value;
      }
    };

    this.addEventListener('change', sync, opts);
    this.addEventListener('input', sync, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-variant-sync')) {
  customElements.define('s-variant-sync', SVariantSync);
}
